import {Pressable, View} from "react-native"
import React, {useMemo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/src/shape-component"
import {digs} from "diggerize"
import {HelperText} from "react-native-paper"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import memo from "set-state-compare/src/memo"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import {Text} from "shared/base"
import {useForm} from "@kaspernj/api-maker/build/form"
import useInput from "@kaspernj/api-maker/build/use-input"

export default memo(shapeComponent(class ComponentsChalkyLayoutCheckbox extends ShapeComponent {
  static defaultProps = {
    value: undefined
  }

  static propTypes = propTypesExact({
    checked: PropTypes.bool,
    dataSet: PropTypes.object,
    defaultChecked: PropTypes.bool,
    fontStyle: PropTypes.object,
    hint: PropTypes.node,
    label: PropTypes.string,
    labelContent: PropTypes.node,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onChangeChecked: PropTypes.func,
    style: PropTypes.object,
    testID: PropTypes.string,
    value: PropTypes.object
  })

  setup() {
    const {defaultChecked, name, checked, value} = this.props
    const {wrapperOpts} = useInput({props: this.props, wrapperOptions: {type: "input"}})
    const {errors} = digs(wrapperOpts, "errors")

    this.errors = errors
    this.form = useForm()
    this.useStates({checked: checked || defaultChecked || false})

    if ("checked" in this.props) {
      this.checked = this.p.checked
    } else {
      this.checked = this.s.checked
    }

    // Set initial value in form
    useMemo(() => {
      if (this.form && name) {
        if (this.isArray()) {
          let currentValue = this.form.getValue(name)

          if (currentValue) {
            currentValue = [...currentValue]
          } else {
            currentValue = []
          }

          if (this.s.checked && !currentValue.includes(value)) {
            currentValue.push(value)
          }

          if (!this.s.checked && currentValue.includes(value)) {
            currentValue.splice(currentValue.indexOf(value), 1)
          }

          this.form.setValue(this.arrayInputName(), currentValue)
        } else {
          this.form.setValue(name, checked)
        }
      }
    }, [])
  }

  render() {
    const {checked, errors} = this.tt
    const {dataSet, fontStyle, hint, label, labelContent, style, testID} = this.props
    const actualDataSet = Object.assign({}, dataSet, {checked})
    const viewStyle = useMemo(() => ({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 32,
      height: 32,
      backgroundColor: checked ? "#5253ff" : "#f0f4fc",
      borderRadius: 8
    }),
    [checked])

    const actualFontStyle = useMemo(() =>
      Object.assign(
        {
          flex: 1,
          color: "#2c2c96",
          fontWeight: 500
        },
        fontStyle
      ),
    [fontStyle])

    return (
      <View dataSet={actualDataSet} style={style}>
        <Pressable
          dataSet={this.pressableDataSet ||= {class: "checkbox-pressable"}}
          onPress={this.tt.onCheckboxPressed}
          style={this.pressableStyle ||= {display: "flex", flexDirection: "row", alignItems: "center"}}
          testID={testID}
        >
          <View style={viewStyle}>
            {checked &&
              <Icon name="check" size={16} style={this.iconStyle ||= {color: "#fff"}} />
            }
          </View>
          {(label || labelContent) &&
            <View style={this.labelStyle ||= {flexDirection: "row", flex: 1, marginLeft: 10}}>
              {label &&
                <Text style={actualFontStyle}>
                  {label}
                </Text>
              }
              {labelContent}
            </View>
          }
        </Pressable>
        {hint &&
          <View style={this.hintStyle ||= {marginTop: 4}}>
            {hint}
          </View>
        }
        {errors.length > 0 &&
          <HelperText dataSet={this.errorMessagesStyle ||= {class: "errors-helper-text"}} type="error">
            {this.errorMessages().join(". ")}
          </HelperText>
        }
      </View>
    )
  }

  errorMessages() {
    const {errors} = this.tt
    const errorMessages = []

    for (const error of errors) {
      for (const errorMessage of error.getErrorMessages()) {
        errorMessages.push(errorMessage)
      }
    }

    return errorMessages
  }

  isArray() {
    return this.props.name?.endsWith("[]")
  }

  arrayInputName() {
    return this.props.name.replace(/\[\]$/, "")
  }

  onCheckboxPressed = () => {
    const {form} = this.tt
    const {name, value} = this.props
    const newChecked = !this.tt.checked

    if (form && name) {
      if (this.isArray()) {
        let currentValue = this.form.getValue(name)

        if (currentValue) {
          currentValue = [...currentValue]
        } else {
          currentValue = []
        }

        if (newChecked && !currentValue.includes(value)) {
          currentValue.push(value)
        }

        if (!newChecked && currentValue.includes(value)) {
          currentValue.splice(currentValue.indexOf(value), 1)
        }

        this.form.setValue(this.arrayInputName(), currentValue)
      } else {
        form.setValue(name, newChecked)
      }
    }

    if (this.props.onChange) {
      this.p.onChange({
        checked: newChecked,
        label: this.p.label,
        value: this.p.value
      })
    }

    if (this.props.onChangeChecked) {
      this.p.onChangeChecked(newChecked)
    }

    this.setState({checked: newChecked})
  }
}))
